import React from "react";
import { Image } from "../../../../components/Image/Image";
import { Product } from "@core/types";

import { getPreviewImage } from "../../../../utils/getPreviewImage";
import { placeholderLogo } from "../../shared/assets/images/images";
import { useTranslation } from "react-i18next";

type MySelectionProps = {
  mySelectionData: Product[];
  onMySelectClick: () => void;
  title: string;
};

const COLLECTION_PRODUCTS_COUNT = 3;

const Selection = ({ mySelectionData = [], onMySelectClick, title }: MySelectionProps) => {
  const { t } = useTranslation();
  const placeholdersCount = COLLECTION_PRODUCTS_COUNT - mySelectionData?.length;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex w-[8.25rem] lg:w-[10.5rem] flex-wrap  gap-1 lg:gap-1.5" onClick={onMySelectClick}>
        {mySelectionData.map((product, index) => {
          const previewSrc = getPreviewImage(product.images?.[0]);

          const cornerClass = [
            "rounded-tl-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
            "rounded-tr-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
            "rounded-bl-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
          ][index];

          return (
            <div key={product.id} className={`flex items-center justify-center overflow-hidden ${cornerClass}`}>
              <Image image={previewSrc} className="h-[4rem] w-[4rem] lg:h-[5rem] lg:w-[5rem]" placeholder={placeholderLogo} />
            </div>
          );
        })}

        {[...Array(placeholdersCount)].map((_, index) => {
          const cornerClass = [
            "rounded-tl-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
            "rounded-tr-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
            "rounded-bl-3xl shadow-[0_0_0_1px_rgba(34,60,80,0.21)]",
          ][mySelectionData.length + index];

          return (
            <div
              key={`placeholder-${index}`}
              className={`flex items-center justify-center overflow-hidden ${cornerClass}`}
            >
              <Image image={undefined} placeholder={placeholderLogo} className="h-[4rem] w-[4rem] lg:h-[5rem] lg:w-[5rem]" />
            </div>
          );
        })}

        <div className="flex items-center justify-center h-[4rem] w-[4rem] lg:h-[5rem] lg:w-[5rem] text-[#6F6F6F] rounded-br-2xl bg-white text-base font-medium shadow-[0_0_0_1px_rgba(34,60,80,0.21)]">
          {t("All")}
        </div>
      </div>

      <div className="text-sm lg:text-base font-normal text-[#6F6F6F]">{title}</div>
    </div>
  );
};

export default Selection;
